import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    storageKey: { type: String, default: 'sidebar-collapsed' },
    attribute: { type: String, default: 'data-collapsed' }
  }

  connect () {
    if (window.localStorage.getItem(this.storageKeyValue) === 'true') {
      this.setCollapsed(true)
    }

    window.requestAnimationFrame(() => {
      this.element.setAttribute('data-sidebar-ready', '')
    })

    this.morphListener = window.addEventListener('turbo:morph', () => {
      if (window.localStorage.getItem(this.storageKeyValue) === 'true') {
        this.setCollapsed(true)
      }
    })
  }

  disconnect () {
    window.removeEventListener('turbo:morph', this.morphListener)
  }

  setCollapsed (collapsed) {
    if (collapsed) {
      this.element.setAttribute(this.attributeValue, '')
    } else {
      this.element.removeAttribute(this.attributeValue)
    }
  }

  toggle () {
    const isCollapsed = this.element.hasAttribute(this.attributeValue)

    if (isCollapsed) {
      this.element.removeAttribute(this.attributeValue)
      window.localStorage.setItem(this.storageKeyValue, 'false')
    } else {
      this.element.setAttribute(this.attributeValue, '')
      window.localStorage.setItem(this.storageKeyValue, 'true')
    }

    window.setTimeout(() => {
      window.dispatchEvent(new window.Event('resize'))
    }, 350)
  }
}
